import React, { useRef } from 'react';
import Editor from '@monaco-editor/react';
import './CodeEditor.css';

const CodeEditor = ({ value, onChange, onMount, onContentChange, placeholder = "# Write your code here...", readOnly = false, language = "python" }) => {
  const editorRef = useRef(null);

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    // Expose editor ref to parent via onMount callback
    if (onMount && typeof onMount === 'function') {
      onMount(editor);
    }
  };

  const handleEditorChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
    // Also call onContentChange for autosave triggers
    if (onContentChange) {
      onContentChange(newValue);
    }
  };

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    }}>
      <Editor
        height="100%"
        defaultLanguage={language}
        value={value || placeholder}
        theme="vs"
        onChange={handleEditorChange}
        onMount={handleEditorDidMount}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          fontFamily: '"Monaco", "Menlo", "Ubuntu Mono", "Consolas", "source-code-pro", monospace',
          lineNumbers: 'on',
          roundedSelection: false,
          scrollBeyondLastLine: false,
          readOnly: readOnly,
          automaticLayout: true,
          tabSize: 4,
          insertSpaces: true,
          wordWrap: 'off',
          suggestOnTriggerCharacters: true,
          acceptSuggestionOnEnter: 'on',
          quickSuggestions: true,
          parameterHints: { enabled: true },
        }}
      />
    </div>
  );
};

// Expose a method to get current editor value
CodeEditor.getValue = (editorRef) => {
  return editorRef.current?.getValue() || '';
};

export default CodeEditor;
